module.exports = __webpack_public_path__ + "img/eventLoading2.c361269d.svg";